<div class="widget-tile">
  <span>{{ widgetDataHolder.title }}</span>
  <canvas baseChart
          [data]="pieChartData"
          [labels]="pieChartLabels"
          [options]="pieChartOptions"
          [plugins]="pieChartPlugins"
          [legend]="pieChartLegend">
  </canvas>
</div>
